
// novoPedido_POS.jsx
// Versão POS completa: integração dos modais de Adição e Recebimento inline
// Mantém toda a lógica original do arquivo `novoPedido.jsx` e reimplementa
// o ModalAdicaoItem como seção embutida, preservando atalhos e comportamentos.

import './pedidos.css';
import Navbar from "../navbar/navbar";
import { useState, useEffect, useRef } from 'react';
import BuscaVazaia from '../components/buscavazia/buscaVazia';
import api from '../../services/api';
import { vhostV1, vhostV2 } from '../funcoes';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { NumericFormat } from 'react-number-format';
import SweetAlert from 'react-bootstrap-sweetalert';
import ModalProduto from '../components/modalProduto/ModalProduto';
import Finalizadora from '../financeiro/Finalizadora/finalizadora';
import Card from './card';
import FooterBar from '../footer/footerBar';
import ModalCadastroCliente from './cadastroCliente';
import './pos_layout.css';
import { motion, AnimatePresence } from "framer-motion";

// NOTE: Este arquivo substitui o `novoPedido.jsx` atual com uma versão POS
// que incorpora o antigo ModalAdicaoItem e o modal Recebimento diretamente
// na página. Comentários com 👉 marcam os pontos onde os modais originais
// foram substituídos por seções inline.

function NovoPedidoPOS(){
  const navigate = useNavigate();

  // --------------------------- Config ---------------------------
  const config = { headers: { 'Authorization': localStorage.getItem("token") } };
  const config2 = { headers: { 'Authorization': localStorage.getItem("token2") } };

  // --------------------------- Estados principais (originais) ---------------------------
  const [dataAtual, setDataAtual] = useState(new Date());
  const [finalizadora, setFinalizadora] = useState([]);
  const [finalizadorasFiltradas, setFinalizadorasFiltradas] = useState([]);
  const [razao,setRazao] = useState('CADASTRO PADRÃO');
  const [buscaPessoa,setBuscaPessoa] = useState("");
  const [resultPessoa,setResultPessoa] = useState();
  const [pessoas,setPessoas] = useState();
  const [responsavel,setResponsavel] = useState();
  const [sResult,setSresult] = useState(0);
  const [confirmacao,setConfirmacao] = useState(false);
  const [confirmacaoId,setConfirmacaoID] = useState('');
  const [result, setResult] = useState(0);
  const [total,setTotal] = useState(0);
  const [Itens,setItens] = useState([]);
  const [idVenda,setIdVenda] = useState(0);
  const [totalPedido,setTotalPedido] = useState(0);
  const [sucesso,setSucesso]      = useState('N')
  const [mensagem, setMensagem]   = useState('');
  const [dataEmissao,setDataEmissao] = useState(new Date)
  const [formaPag,setFormaPag] = useState({codigo: 0,descricao: ''});
  const [redePag,setRedePag] = useState({cnpj: '',nome: '', nLogico: ''});
  const [recebebido,setRecebito] = useState(0);
  const [sucessoBusca,setSucessoBusca] = useState(false);
  const [produtos,setProdutos] = useState([]);
  const [buscaProduto,setBuscaProduto] = useState('');
  const [cliente,setCliente] = useState(0);
  const [vendedor, setVendedor] = useState(0);
  const [vendedorDesc, setVendedorDesc] = useState(localStorage.getItem('usuario'));
  const [gridProduto,setGridProduto] = useState(false);
  const [subTotal, setSubTotal] = useState(0);
  const [nr, setNr] = useState("");
  const [valorTotalPago, setValorTotalPago] = useState(0);
  const [pagamentos, setPagamentos] = useState([]);
  const [valorASerPago, setValorASerPago] = useState(0);
  const [valorPago, setValorPago] = useState(0);
  const [pagamentosRealizados, setPagamentosRealizados] = useState([]);
  const [descricaoForma, setDescricaoForma] = useState('');
  const [confirmaPagamento, setConfirmaPagamento] = useState(false);
  const [autorizaFechamento, setAutorizaFechamento] = useState(false);
  const [navegar, setNavegar] = useState(false);
  const [key, setKey] = useState(0);
  const [load, setLoad] = useState(false);
  const [confirmaEmissao, setConfirmaEmissao] = useState(false);
  const [msgErro, setmsgErro] = useState('');
  const [erroEmissao, setErroEmissao] = useState(false);
  const [erroValidacao, setErrovalidacao] = useState(false);

  const [fantasia,setFantasia] = useState('');   
  const [cnpj,setCnpj] = useState('');
  const [inscEstadual,setEstadual] = useState('');
  const [inscMunicipal,setMunicipal] = useState('');
  const [endereco,setendereco] = useState('');
  const [bairro,setbairro] = useState('');
  const [cep,setcep] = useState('');
  const [cidade,setcidade] = useState('');
  const [fone,setfone] = useState('');
  const [uf,setuf] = useState('');
  const [desconto, setDesconto] = useState(0);
  const [descontoDefault, setDescontoDefault] = useState('');
  const [valorDescontado, setValorDescontado] = useState('');
  const [tipoDoc, setTipoDoc] = useState(0);
  const [numeroPedido, setNumeroPedido] = useState(0);
  const [pedidos, setPedidos] = useState([]);
  const [tipo,setTipo] = useState('TODOS');
  const [caixa,setCaixa] = useState('TODOS');  
  const [dataInical,setDataInicial] = useState(new Date()); 
  const [dataFinal,setDataFinal] = useState(new Date());
  const [totalComDesconto, setTotalComDesconto] = useState(0);
  const [campoVisivel, setCampoVisivel] = useState(true);
  const [isDisabled, setIsDisabled] = useState(true);
  const [dataAtualFormatada, setDataAtualFormatada] = useState('');
  const [nPag, setnPag] = useState(1);
  const [CpfCadastrado, setCpfcadastrado] = useState('');
  const [codcadastrado, setCodCadastro] = useState('');
  const [razaoCadastrado, setRazaoCadastrado] = useState('');
  const [nsu, setNsu] = useState('');
  const [escolhaNota, setEscolhaNota] = useState(false);
  const [notaCnpj, setNotaCnpj] = useState(false);
  const [notaCadPadrao, setNotaCadPadrao] = useState(false);
  const [confirmaVenda, setConfirmaVenda] = useState(false);
  const [bandeiraSelecionada, setBandeiraSelecionada] = useState('');
  const [redes,setRedes] = useState("");
  const [redeSelecionada, setRedeSelecionada] = useState('');
  const [pixAccessToken, setPixAccessToken] = useState('');
  const [busca, setBusca] = useState('');
  const [vendedores, setVendedores] = useState([]);
  const [codVendedor, setCodVendedor] = useState(0);
  const [produtoCarregado, setProdutoCarregado] = useState(false);
  const [processando, setProcessando] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [clienteId, setClienteId] = useState(0);

  const pixAcessKey = "UToblBcZB_D8CE2-yyU0pg";
  const pixSecretKey = "CnLV6It9ZDBn0qKZUuah6-gu3mYoo2Xya91-ZLUOqkZrE6fNLKCakr2_1reDHgTbnsCqP4qYT6PgnQLJYQkwFw";
  const pixClientId = "QYC9DMGQkmAOVyEVdvuQPrIKAqdYPiLu9j4s4hPrc_acya3xYNRyBNVaUzi47XxToCx6NBYkZIWyyM0i8vo3ccVjaA-YmbVaoCfkqJD8_Xv_3Owc1AY1-yPRHfnsmsrQHfrm8IjiiTXNlvgr3QWgQUYQO11Q3DeYaBw-y-EI6XU";   

  const [isNovoClienteOpen, setIsNovoClienteOpen] = useState(false);

  const bandeiras = [ /* ...lista como antes...*/ ];

  // --------------------------- Fetch finalizadoras e redes ---------------------------
  useEffect(() => {
    api.post(vhostV1('webcash/vendas/listarBandeiras'),{},config)
      .then(function(response){
       setRedes(response.data.dados);
       console.log(response);
       
      }).catch(function(error){ console.log(error); })

    api.get(vhostV1('webcash/finalizadoras/ListaFinalizadoras'), config)
      .then(function (response) {
          if (response && response.data && response.data.dados){
            console.log(response);
            
            const dados = response.data.dados;
            setFinalizadora(dados);
            const filtradas = dados.filter(forma => forma.COD_FINALIZADORA <= 90);
            setFinalizadorasFiltradas(filtradas);
            setResult(1);
          }else{
            setResult(0);
          }       
      })
      .catch(function (error) { console.log(error); });
  },[])

  useEffect(() => {
    if (tipoDoc) {
      const filtradas = finalizadora.filter(
        forma => forma.TIPO_DOC === tipoDoc && forma.COD_FINALIZADORA <= 90
      );
      setFinalizadorasFiltradas(filtradas);
    }
  }, [tipoDoc, finalizadora]);

  // --------------------------- Inicia venda ---------------------------
  useEffect(function(){
    api.post(vhostV1('webcash/vendas/iniciarVenda'), {
      empresa:0,
      idMesa: 1,
      codigoColaborador: Number(localStorage.getItem("colaborador")),
      quantidadePessoas: 1,
      nome: "",
      caixa: "001",
      codIndicado: ""
     },config)
     .then(function (response) {
      setIdVenda(response.data.codigoOrcamento);
     })
     .catch(function (error) { console.log(error); });    
  },[])

  // --------------------------- Funções utilitárias ---------------------------
  function formatDate(dateString) { const [year, month, day] = dateString.split("-"); return `${day}/${month}/${year}`; }
  function converterParaInputDate(dataISO) { const data = new Date(dataISO); const ano = data.getFullYear(); const mes = String(data.getMonth() + 1).padStart(2, '0'); const dia = String(data.getDate()).padStart(2, '0'); return `${ano}-${mes}-${dia}`; }
  useEffect(function(){ setDataAtual(converterParaInputDate(dataAtual)) },[])

  // --------------------------- Retorna Venda ---------------------------
  function retornaVenda(){
    if(!idVenda) return;
    api.post(vhostV1('webcash/vendas/retornaVenda/'+idVenda),{codOrcamento: Number(idVenda)},config)
     .then(function (response) {
      console.log(response);
      
        const dados = response.data.dados;
          setTotalPedido(dados.TOTAL);
          setNumeroPedido(dados.COD_ORCAMENTO);
          setResponsavel(dados.RESPONSAVEL);
          setDesconto(dados.DESCONTO);
            if(dados.itens.length > 0){ setItens(dados.itens); } else { setItens([]); }
     })
     .catch(function (error) { console.log(error); });
  }

  useEffect(() => { setTotalComDesconto(Number(totalPedido)) }, [totalPedido, desconto])

  const totalDesconto = Itens.reduce((acc, item) => acc + item.DESCONTO, 0);
  const valorNota = totalPedido;
 
 
  const formatCurrency = (value) => value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });

  // --------------------------- ModalProduto (usado tanto no add item quanto em pesquisa) ---------------------------
  const [isProdutoOpen, setIsProdutoOpen] = useState(false);

  // --------------------------- ModalCliente (mantido) ---------------------------
  // (o seu modal de pesquisa de clientes permanece com data-bs-toggle no markup original)

  // --------------------------- Adição de Item inline (integração do ModalAdicaoItem) ---------------------------
  // 👉 agora inline: variáveis com prefixo item*
  const [itemCodProduto,setItemCodProduto] = useState('');
  const [itemDescricao,setItemDescricao] = useState('');
  const [itemVendaDefault,setItemVendaDefault] = useState('');
  const [itemVenda,setItemVenda] = useState('');
  const [itemDesconto,setItemDesconto] = useState(0);
  const [itemQtd,setItemQtd] = useState(1);
  const [itemTotal,setItemTotal] = useState(0);
  const [itemTotalComDesconto, setItemTotalComDesconto] = useState(0);
  const [itemMsgErro, setItemMsgErro] = useState('');
  const [itemErroValidacao,setItemErrovalidacao] = useState(false);
  const [itemNcm, setItemNcm] = useState(0);
  const [itemCompra, setItemCompra] = useState(0);
  const [itemEstoque, setItemEstoque] = useState(0);
  const [itemCampoVisivel, setItemCampoVisivel] = useState(false);

  useEffect(() => { setItemTotalComDesconto(Number(itemTotal - itemDesconto)) }, [itemTotal, itemDesconto]);

async function buscaItem() {
  if (!itemCodProduto) return;

  let codigoProduto = itemCodProduto;
  let valorVendaManual = null;

  // 🧠 Verifica se é código de balança (13 dígitos e inicia com 2)
  if (codigoProduto.length === 13 && codigoProduto.startsWith("2")) {
    const codigoInterno = codigoProduto.slice(1, 7); // dígitos 2–7
    const valorStr = codigoProduto.slice(7, 12);     // dígitos 8–12

    // 🔢 Remove zeros à esquerda do código
    const codigoSemZeros = parseInt(codigoInterno, 10).toString();

    // 💰 Converte valor 8–12 para reais (ex: "01799" → 17.99)
    valorVendaManual = parseFloat((parseInt(valorStr, 10) / 100).toFixed(2));

    // Atualiza o código que será usado na busca
    codigoProduto = codigoSemZeros;
  }

  try {
    const response = await api.post(
      vhostV1('webcash/produto/retornaproduto/' + codigoProduto),
      { loja: localStorage.getItem('loja'), empresa: 0 },
      config
    );

    console.log(response);

    if (response.data.dados.length === 0) {
      setmsgErro('Produto não encontrado!');
      setErrovalidacao(true);
      return;
    }

    const p = response.data.dados[0];

    // Usa o valor vindo da balança se existir, senão o da API
    const valorVenda = valorVendaManual !== null ? valorVendaManual : Number(p.VENDAS);
    const total = valorVenda * itemQtd - itemDesconto;

    // Atualiza o estado para exibir na tela
    setItemDescricao(p.DESCRICAO);
    setItemVendaDefault(valorVenda);
    setItemVenda(valorVenda);
    setItemTotal(total);

    // 🚀 Adiciona item imediatamente com os dados locais
    await adicionarItemInline(null, {
      codigo: codigoProduto,
      descricao: p.DESCRICAO,
      quantidade: itemQtd,
      valor: valorVenda,
      total: total,
    });

  } catch (error) {
    console.log(error);
  }
}
useEffect(() => {
  if (produtoCarregado) {
    (async () => {
      await adicionarItemInline(); // adiciona item
      setProdutoCarregado(false);  // reseta o flag para não repetir
    })();
  }
}, [produtoCarregado]);

  function itemMostrarCampo(){ setItemCampoVisivel(!itemCampoVisivel); }

async function adicionarItemInline(e, produto = null) {
  if (e) e.preventDefault();

  // Usa os dados vindos do produto (se passados), senão usa os do estado
  const codigo = produto?.codigo ?? itemCodProduto;
  const descricao = produto?.descricao ?? itemDescricao;
  const qtd = produto?.quantidade ?? itemQtd;
  const valor = produto?.valor ?? itemVendaDefault;
  const total = produto?.total ?? itemTotalComDesconto;

  if (!codigo) return;
  if (Number(total) <= 0) {
    setItemMsgErro('Total não pode ser 0!');
    setItemErrovalidacao(true);
    return;
  }
  if (Number(qtd) <= 0) {
    setItemMsgErro('Quantidade deve ser diferente de 0!');
    setItemErrovalidacao(true);
    return;
  }

  try {
    const response = await api.post(
      vhostV1('webcash/vendas/itens'),
      {
        codigoOrcamento: Number(idVenda),
        codigoColaborador: 99,
        codigoProduto: codigo,
        obs: "",
        desconto: Number(itemDesconto),
        quantidade: Number(qtd),
        valor: Number(valor),
        total: Number(total),
        caixa: "001",
        vendedor: 0
      },
      config
    );

    console.log(response);

    // limpa campos
    setItemCodProduto('');
    setItemDesconto('');
    setItemDescricao('');
    setItemVenda('');
    setItemQtd(1);
    setItemTotal('');
    setItemVendaDefault('');
    setItemCampoVisivel(false);

    retornaVenda();

    // foco de volta
    setTimeout(() => document.getElementById("inputCod")?.focus(), 100);

  } catch (error) {
    console.log(error);
  }
}

  // Atalhos dentro da adição de item (F8 para pesquisa, F6 mostra campo, F7 confirmar)
  useEffect(() => {
    const handleItemKeys = (event) => {
      switch (event.key) {
        case 'F8': event.preventDefault(); setIsProdutoOpen(true); break;
        case 'F6': event.preventDefault(); itemMostrarCampo(); break;
        case 'F7':
  event.preventDefault();
  document.getElementById('select-pag')?.focus();
  break;
        default: break;
      }
    };
    document.addEventListener('keydown', handleItemKeys);
    return () => document.removeEventListener('keydown', handleItemKeys);
  }, [itemCodProduto, itemQtd, itemTotal, itemDesconto, itemTotalComDesconto]);

  // --------------------------- Pagamento / Recebimento inline (substituição do modal exampleModal) ---------------------------
  // Função usada no original: gravaRecDav
  function gravaRecDav( valorRecebido,descricaoPagamento, finalizadoraCod, rede){
    api.post(vhostV1('webcash/vendas/gravarRecDav'),{
  loja: Number(localStorage.getItem('loja')),
  empresa:0,
  seq:1,
  idOrcamento:idVenda,
  data: '',       
  hora :'',      
  sValor: valorRecebido,     
  nsu: nsu.length > 0 ? nsu : "000000",        
  autorizacao:'000000',

  rede:'0000',

  produto: descricaoPagamento,
  tipo: descricaoPagamento,       
  nrParcelas:1, 

  logico: (finalizadoraCod === 2 || finalizadoraCod === 3) 
    ? rede?.nLogico || '000000' 
    : '000000',

  cnpjAdquirente: (finalizadoraCod === 2 || finalizadoraCod === 3) 
    ? rede?.cnpj || '00000000000' 
    : '00000000000',

  idRemoto:1,
  codFinalizadora: finalizadoraCod,
}, config)
    .then(function (response) {
      setRecebito(1);
    })
    .catch(function (error) {
      setRecebito(0); console.log(error);
    });
  }

  const gravaRecebimentos = () => {
  pagamentos.forEach((pagamento) => {
    gravaRecDav(
      pagamento.valor,              
      pagamento.formaPagamento,      
      pagamento.codigoFinalizadora,
      pagamento.rede 
    );
  });
  setConfirmaPagamento(true);
};

  // registrarPagamento (mantido do original) com adaptações
  const registrarPagamento = async (event) => {
    if (event) event.preventDefault();
     if (processando) return; // Evita cliques duplos
     setProcessando(true);
    if (formaPag.codigo === 0 || formaPag.codigo === null) {
      setmsgErro("Selecione uma forma de pagamento"); setErrovalidacao(true); return;
    }
    
   
    

    const valorPagar = parseFloat(`${valorASerPago}`.toString().replace('.', ',').replace(',', '.'));
    const valorSobra = totalComDesconto - valorTotalPago;

    try {

    const response = await api.get(
      vhostV1(`webcash/finalizadoras/retornaFinalizadora/${formaPag.codigo}`),
      config
    );

    const finalizadora = response.data.dados;
    console.log(finalizadora);
    

    const numeroParcelas = finalizadora.NR_PARCELAS || 1;
    const valorMinimo = Number(finalizadora.VLR_MINIMO_OP) || 0;
    const valorParcela = Number((valorPagar / numeroParcelas).toFixed(2));

    if (valorMinimo > 0 && valorParcela < valorMinimo) {
      setmsgErro("Parcelas menores que o valor minimo necessário");
      setErrovalidacao(true);
      setProcessando(false);
      return; // 🔥 agora realmente para aqui
    }
    if(clienteId < 1 && finalizadora.GERCR === 'S' && finalizadora.COD_FINALIZADORA !== 1){
      setmsgErro("Cliente deve ser selecionado para esta forma de pagamento");
      setErrovalidacao(true);
      setProcessando(false);
      return;
    }

  } catch (error) {
    console.log(error);
    setProcessando(false);
    return;
  }

    if (valorPagar > 0 && valorPagar <= valorSobra) {
      const novoPagamento = { 
  formaPagamento: formaPag.descricao, 
  valor: valorPagar, 
  codigoFinalizadora: formaPag.codigo,
  rede: (formaPag.codigo === 2 || formaPag.codigo === 3) ? redePag : null
};;
      setPagamentos(prev => [...prev, novoPagamento]);
      setValorTotalPago(prev => prev + valorPagar);
      setValorPago(prev => prev + valorPagar);
      setPagamentosRealizados(prev => {
        const index = prev.length; const pagamentoRealizadoAtualizado = { ...(prev[index] || {}), valor: (prev[index]?.valor || 0) + valorPagar }; const novos = [...prev]; novos[index] = pagamentoRealizadoAtualizado; return novos;
      });
      setValorASerPago((totalComDesconto - (valorTotalPago + valorPagar)).toFixed(2).replace('.', ','));
      if (valorTotalPago + valorPagar >= totalComDesconto) { calcularTroco(); }
    } else if (valorPagar >= valorSobra) {
      const pagamento = { 
  formaPagamento: formaPag.descricao, 
  valor: valorPagar, 
  codigoFinalizadora: formaPag.codigo,
  rede: (formaPag.codigo === 2 || formaPag.codigo === 3) ? redePag : null
};;
      setPagamentos(prev => [...prev, pagamento]);
      setValorTotalPago(prev => prev + pagamento.valor);
      setValorPago(prev => prev + valorPagar);
      setPagamentosRealizados(prev => { const index = prev.length; const pagamentoRealizadoAtualizado = { ...(prev[index] || {}), valor: (prev[index]?.valor || 0) + pagamento.valor }; const novos = [...prev]; novos[index] = pagamentoRealizadoAtualizado; return novos; });
      setValorASerPago((totalComDesconto - (valorTotalPago + pagamento.valor)).toFixed(2).replace('.', ','));
      setTroco(valorPagar - valorSobra);
    } else { console.log('Valor inválido ou excede o valor restante.'); }
    setTimeout(() => setProcessando(false), 300);
  };

  const removerPagamento = (index) => {
  setPagamentos((prevPagamentos) => {
    const pagamentoRemovido = prevPagamentos[index];
    if (!pagamentoRemovido) return prevPagamentos;

    const novosPagamentos = prevPagamentos.filter((_, i) => i !== index);

    // Atualiza valores
    const novoTotalPago = valorTotalPago - pagamentoRemovido.valor;
    const novoRestante = totalComDesconto - novoTotalPago;
    const novoTroco = novoRestante < 0 ? Math.abs(novoRestante) : 0;

    setValorTotalPago(novoTotalPago);
    setValorPago(novoTotalPago);
    setValorASerPago(novoRestante.toFixed(2).replace('.', ','));
    setTroco(novoTroco);

    return novosPagamentos;
  });
};

  const [troco, setTroco] = useState(0);
  const calcularTroco = () => {
    const valorPagar = parseFloat(String(valorASerPago).replace('.', ',').replace(',', '.'));
    const calculo = valorPagar - (totalComDesconto - valorTotalPago);
    if (calculo >= 0) { setTroco(calculo); } else { alert('Valor insuficiente para completar o pagamento.'); }
  };

  const resetarValores = () => { setFormaPag({codigo:0, descricao:''}); setValorTotalPago(0); setPagamentos([]); setPagamentosRealizados([]); setValorASerPago(totalComDesconto); }

  const handleChange = (e) => {
      const selectedValue = e.target.value;
      const selectedOption = finalizadorasFiltradas.find(forma => forma.DESCRICAO === selectedValue);
  
      if (selectedOption) {
        setDescricaoForma(selectedValue);
        setFormaPag({
          descricao: selectedValue,
          codigo: selectedOption.COD_FINALIZADORA
        });
        setTipoDoc(selectedOption.TIPO_DOC); 
      }
    };

    const handleChangeRede = (e) => {
      const selectedValue = e.target.value;
      const selectedOption = redes.find(forma => forma.NOME_REDE === selectedValue);

      if (selectedOption) {   
        setRedePag({
          nome: selectedValue,
          nLogico: selectedOption.N_LOGICO,
          cnpj: selectedOption.CNPJ
        });
      }
    };


  // --------------------------- Emissão / fechamento ---------------------------
  function fecharVenda(){
    setAutorizaFechamento(false);
    api.post(vhostV1('webcash/vendas/fecharDav'), {
      iPedido: Number(idVenda), tipo: 1, data: dataAtual, doc: tipoDoc, troco: troco, colaborador: Number(localStorage.getItem('colaborador')),
    },config)
    .then(function(response){
      setMensagem(''); setConfirmaPagamento(false);
      if(tipoDoc > 0 && cnpj.length === 11){ setEscolhaNota(true); }
      else if(tipoDoc > 0 && cnpj.length === 0){ setNotaCadPadrao(true); }
      else if(tipoDoc > 0 && cnpj.length > 11){ setNotaCnpj(true); }
      else{ vendaSemNfce(numeroPedido); }
    }).catch((erro) =>{ setMensagem(erro); setSucesso('N'); setConfirmaPagamento(false); });
  }

  async function enviarNFce (npedido,tipo){
    if (load) return;
    setConfirmacao(false);
  setEscolhaNota(false);
  setNotaCnpj(false);
  setNotaCadPadrao(false);
    setLoad(true);
    const sJson = { loja:localStorage.getItem('loja'), empresa:0, dav:String(npedido), tipo:tipo, tag:1 };
    const res = await api.post(vhostV1('webcash/nfe/emitir/nfe'), sJson, config).catch(e=>{ setLoad(false); setmsgErro(e); setErroEmissao(true); });
    console.log(res);
    
    if(res && res.status===200){ setConfirmaEmissao(true); setLoad(false)}else if(res.status===500){setmsgErro(res.data.detalhes); setErroEmissao(true); setLoad(false); }
  }

  const vendaSemNfce = async(npedido)=>{
    setLoad(true)
    const sJson = { loja: localStorage.getItem('loja'), empresa:0, id_orcamento:npedido, caixa:'001', troco:troco };
    api.post(vhostV1('webcash/vendas/orcamentoxvenda'), sJson, config)
      .then(function(response){ setConfirmaVenda(true); setLoad(false); })
      .catch((erro) =>{ setSucesso('N'); setLoad(false); console.log(erro); })
  }

  // --------------------------- Excluir item ---------------------------
  function confirmadeleteUser(id){ setConfirmacaoID(id); setConfirmacao(true); }
  function deleteUser(id){
    api.post(vhostV1('webcash/vendas/cancelaItem'), { loja: localStorage.getItem('loja'), pedido:idVenda, item:id, empresa: 0 },config)
    .then(function (response) {console.log(response);
     setConfirmacao(false); retornaVenda(); })
    .catch(function (error) { console.log(error); setConfirmacao(false); });
  }

  // ------------------------- Atualiza desconto ---------------------------

  function editarDesconto(itemId) {
  setItens(prev =>
    prev.map(it =>
      it.ITEM === itemId ? { ...it, editandoDesconto: true } : it
    )
  );
}

function cancelarEdicao(itemId) {
  setItens(prev =>
    prev.map(it =>
      it.ITEM === itemId ? { ...it, editandoDesconto: false, novoDesconto: undefined } : it
    )
  );
}

function formatCurrencyInput(value) {
  if (value === null || value === undefined) return "";
  
  // remove tudo que não for número
  const cleanValue = value.toString().replace(/\D/g, "");
  
  if (!cleanValue) return "";

  // divide por 100 pra tratar centavos
  const numericValue = parseFloat(cleanValue) / 100;

  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(numericValue);
}

function handleDescontoChange(itemId, valorDigitado) {
  // Remove símbolos e converte para número puro
  const cleanValue = valorDigitado.replace(/\D/g, "");

  setItens((prev) =>
    prev.map((it) =>
      it.ITEM === itemId
        ? { ...it, novoDesconto: cleanValue }
        : it
    )
  );
}

function salvarDesconto(item) {
  const desconto = parseFloat(item.novoDesconto) / 100 || 0;
   if (isUpdating) return;
   setIsUpdating(true);

  api.post(
    vhostV1("webcash/vendas/aplicaDescontoItem"),
    {
      loja: localStorage.getItem("loja"),
      pedido: idVenda,
      item: item.ITEM,
      desconto: desconto, // já em valor decimal
      empresa: 0,
    },
    config
  )
  .then(function (response) {
    if (response.data.result === 1) {
      setItens((prev) =>
        prev.map((it) =>
          it.ITEM === item.ITEM
            ? { ...it, DESCONTO: desconto, editandoDesconto: false, novoDesconto: undefined }
            : it
        )
      );
      retornaVenda();
      setIsUpdating(false);
    } else {
      alert("Erro ao aplicar desconto: " + response.data.message);
      setIsUpdating(false);
    }
  })
  .catch(function (error) {
    console.log(error);
    alert("Erro ao aplicar desconto no item.");
    setIsUpdating(false);
  });
}
  // --------------------------- Selecionar vendedor ---------------------------
  useEffect(function(){ api.post(vhostV1('webcash/colaborador/listarVendedor'), { loja: localStorage.getItem('loja'), empresa: 0, busca: busca, pagina: 1, regPag: 100, inativo: false },config)
    .then(function (response) { setVendedores(response.data.dados); }).catch(function (error) { console.log(error); }); },[busca])

  function attCodColaborador(e) {
    api.post(vhostV1('webcash/vendas/attColaboradorOrcamento'), { cod_orcamento: Number(idVenda), cod_colaborador: Number(e) }, config)
    .then(function (response) { console.log(response); })
    .catch(function (error) { console.log(error); });
  }

  const handleSelecionarVendedor = (v) => { setVendedor(v.ID); setVendedorDesc(v.NOME); attCodColaborador(v.ID); };

  // --------------------------- Pesquisa / Cadastro de pessoa ---------------------------
  function listaPessoaCad(){
    api.post(vhostV1('webcash/cadastro'), { loja: localStorage.getItem('loja'), empresa: 0, tipo:"C", busca: CpfCadastrado, pagina: nPag, regPag: 10, },config)
    .then(function (response) { setCodCadastro(response.data.dados[0].COD_CADASTRO); setRazaoCadastrado(response.data.dados[0].RAZAO); })
    .catch(function (error) { console.log(error); });
  }

  function openModalAddCliente(){ setIsNovoClienteOpen(true); }
  function closeModalNovoCliente(){ listaPessoaCad(); setIsNovoClienteOpen(false); if(CpfCadastrado !== '' && CpfCadastrado !== null){ pesquisaPessoa(CpfCadastrado); } }

  function adicionaCliente(e){ api.post(vhostV1('webcash/vendas/adicionaCliente'), { cod_orcamento:Number(idVenda), cliente:Number(e), tipo:"P" },config).then(()=>{}).catch((err)=>{console.log(err)}); }

  function listaPessoa(e){ e.preventDefault(); api.post(vhostV1('webcash/cadastro/'), { loja: localStorage.getItem('loja'), empresa: 0, tipo:"", busca: buscaPessoa, pagina: nPag, regPag: 10, },config)
    .then(function (response) { setPessoas(response.data.dados); setResultPessoa(response.data.result); })
    .catch(function (error) { console.log(error); }); }

  function pesquisaPessoa(e){ api.post(vhostV1('webcash/cadastro/'+e), { loja: localStorage.getItem('loja'), empresa: 0, },config)
    .then(function (response) { adicionaCliente(e);setClienteId(e); setRazao(response.data.dados.cadastro.RAZAO); setCnpj(response.data.dados.cadastro.CNPJ); setFantasia(response.data.dados.cadastro.FANTASIA); setbairro(response.data.dados.cadastro.BAIRRO); setcidade(response.data.dados.cadastro.CIDADE); setuf(response.data.dados.cadastro.ESTADO); setfone(response.data.dados.cadastro.TELEFONE); setcep(response.data.dados.cadastro.CEP); setMunicipal(response.data.dados.cadastro.MUNICIPAL); setEstadual(response.data.dados.cadastro.ESTADUAL); setendereco(response.data.dados.cadastro.ENDERECO); setNr(response.data.dados.cadastro.NREND1); })
    .catch(function (error) { console.log(error); }); }

  // --------------------------- Atalhos globais (originais) ---------------------------
  useEffect(() => {
    const handleKeyPress = (event) => {
      // monta uma "string" única pro atalho
      let keyCombo = "";
      if (event.ctrlKey) keyCombo += "CTRL+";
      if (event.shiftKey) keyCombo += "Shift+";
      if (event.altKey) keyCombo += "ALT+";
      keyCombo += event.key.toUpperCase();

      switch (keyCombo) {
        case "F1": event.preventDefault(); document.getElementById("btn-pesquisar-cliente")?.click(); break;
        case "F2": event.preventDefault(); document.getElementById('section-add-item')?.scrollIntoView({ behavior: 'smooth' }); break;
        case "F3": event.preventDefault(); navigate("/app/listapedidos"); break;
        case "F4": event.preventDefault(); document.getElementById('section-pagamento')?.scrollIntoView({ behavior: 'smooth' }); break;
        case "F9": event.preventDefault(); document.getElementById("botao-gravar")?.click(); break;

        case "ALT+S":
          event.preventDefault();
          if (notaCnpj) { enviarNFce(numeroPedido, 55); } else if (notaCadPadrao) { enviarNFce(numeroPedido, 65); } else if (escolhaNota) { enviarNFce(numeroPedido, 55); }
          break;

        case "ALT+N":
          event.preventDefault();
          if (notaCnpj) { vendaSemNfce(numeroPedido); } else if (notaCadPadrao) { vendaSemNfce(numeroPedido); } else if (escolhaNota) { enviarNFce(numeroPedido, 65); }
          break;

        default: break;
      }
    };
    document.addEventListener("keydown", handleKeyPress);
    return () => { document.removeEventListener("keydown", handleKeyPress); };
  }, [navigate, notaCnpj, notaCadPadrao, escolhaNota]);

  // --------------------------- Enter handler para SweetAlert ---------------------------
  useEffect(() => {
    const handleEnter = (event) => {
      if (event.key === "Enter") {
        if (confirmaEmissao) { fecharTelaVenda(); }
        else if (confirmaVenda) { fecharTelaVenda(); }
        else if (confirmaPagamento) { fecharVenda(); }
      }
    };
     if (!confirmaPagamento) {
    // só adiciona enquanto NÃO está pagando
    document.addEventListener("keydown", handleEnter);
  }
    document.addEventListener("keydown", handleEnter);
    return () => document.removeEventListener("keydown", handleEnter);
  }, [confirmaEmissao, confirmaVenda, confirmaPagamento]);

  function fecharTelaVenda(){ setConfirmaEmissao(false); navigate('/app/listapedidos', { state: { reload: true } }); window.location.reload(); }

  // --------------------------- UI helpers ---------------------------
  useEffect(() => { if (valorRestante <= 0) { setCampoVisivel(false); } else { setCampoVisivel(true); } }, [/*valorRestante*/ valorTotalPago, totalComDesconto])
    useEffect(() => { setValorASerPago(totalComDesconto); }, [totalComDesconto]);
 useEffect(() => {
   if(Number(itemVendaDefault) > 0){
     calculaPreco();
   }
 },[itemVendaDefault]);

function calculaPreco(){
  console.log("calculei");
  
  setItemTotalComDesconto(Number(itemVendaDefault) * Number(itemQtd) - Number(itemDesconto));
 
}

async function handleSelecionaProdutoModal(codigoSelecionado) {
  if (!codigoSelecionado) return;

  // Define o código do produto no estado
  setItemCodProduto(codigoSelecionado);

  // Pequeno delay para garantir que o estado propague antes da busca


  // Executa a busca (que automaticamente adiciona o item)
  await buscaItem();

  // Fecha o modal
  setIsProdutoOpen(false);

  // Foca novamente no campo de código

    document.getElementById("inputCod")?.focus();

}
 
  

  // valorRestante calculado
  const valorRestante = totalComDesconto - valorTotalPago;

  // --------------------------- Render ---------------------------
 return (
  <div className="conteiner-fluid titulo pos-page">
    <Navbar />

    {/* Container POS dividido em duas colunas */}
    <div className="container-fluid pos-container">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h4>Novo Pedido (POS)</h4>
        <h5>{localStorage.getItem("usuario").toLocaleUpperCase()}</h5>
      </div>

      <div className="row">
        {/* ========================= COLUNA ESQUERDA ========================= */}
        <div className="col-lg-8 col-md-7 col-sm-12 p-3">
          <form className="row g-3">

            {/* Cabeçalho da venda */}
            <div className="col-3">
              <label className="form-label">Nº PEDIDO</label>
              <input type="text" value={idVenda} className="form-control" readOnly />
            </div>

            <div className="col-5">
              <label className="form-label">VENDEDOR</label>
              <div className="input-group">
                <input type="text" value={vendedorDesc} className="form-control" disabled />
                <button type="button" className="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#modalVendedor">Pesquisar</button>
              </div>
            </div>

            <div className="col-4">
              <label className="form-label">DATA</label>
              <input type="date" value={dataAtual} onChange={(e) => setDataAtual(e.target.value)} className="form-control" disabled={isDisabled} />
            </div>

            {/* Cliente */}
            <div className="col-12 mt-3">
  <label className="form-label">CLIENTE</label>
  <div className="input-group">
    <input type="text" value={razao} className="form-control" disabled />
    <button className="btn btn-primary" onClick={openModalAddCliente} type="button">
      <i className="fas fa-plus-circle"></i>
    </button>
    <button id="btn-pesquisar-cliente" type="button" className="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
      Pesquisar (F1)
    </button>
  </div>

  {/* Modal de Pesquisa */}
  <div className="modal fade mt-5" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div className="modal-dialog modal-lg">
      <div className="modal-content">
        <div className="modal-header">
          <h1 className="modal-title fs-5" id="staticBackdropLabel">Pesquisa Cadastro</h1>
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div className="modal-body">
          <div className="input-group mb-3">
            <input 
              onChange={(e) => setBuscaPessoa(e.target.value)} 
              tabIndex="15" 
              type="text" 
              className="form-control" 
              id="campo-pesquisa-cliente" 
              placeholder="Digite sua pesquisa" 
              aria-describedby="button-addon2" 
              autoFocus 
            />
            <button onClick={listaPessoa} className="btn btn-primary" tabIndex="16" type="button" id="button-addon2">
              <i className="fas fa-search"></i> Pesquisar
            </button>
          </div>

          { resultPessoa === 1 ? (
            <table className="table table-hover table-striped">
              <thead>
                <tr>
                  <th scope="col">Código</th>
                  <th scope="col">Razão</th>
                  <th scope="col">Ação</th>
                </tr>
              </thead>
              <tbody className="table-group-divider">
                {pessoas.map((pessoa) => (
                  <tr key={pessoa.COD_CADASTRO}>
                    <td>{pessoa.CNPJ}</td>
                    <td>{pessoa.RAZAO}</td>
                    <td>
                      <button onClick={() => pesquisaPessoa(pessoa.COD_CADASTRO)} value={pessoa.RAZAO}>
                        <i className="bi bi-file-arrow-down-fill" data-bs-dismiss="modal"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <BuscaVazaia />
          )}
        </div>
        <div className="modal-footer">
          {/* Footer vazio, pode adicionar botões se quiser */}
        </div>
      </div>
    </div>
  </div>
</div>
<div className="accordion accordion-flush mb-2" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                           <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            DADOS DO DESTINATÁRIO
                          </button>
                        </h2>
                        <div id="collapseOne" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                          <div className="accordion-body"></div>

                      <div className="row">
                       
                        <div className="col-8">
                            <label htmlFor="inputAddress" className="form-label">FANTASIA</label>
                            <input type="text"  value={fantasia} className="form-control" id="inputCodigo" tabIndex="1" required autoComplete="off"/>
                        </div>
                        <div className="col-4">
                            <label htmlFor="inputAddress" className="form-label">CNPJ/CPF</label>
                            <input type="text" value={cnpj} className="form-control" id="inputCodigo" tabIndex="1" required autoComplete="off"/>
                        </div>
                        <div className="col-2">
                            <label htmlFor="inputAddress" className="form-label">CEP</label>
                            <input type="text" value={cep} className="form-control" id="inputCodigo" tabIndex="1" required autoComplete="off"/>
                        </div>
                        <div className="col-1">
                            <label htmlFor="inputAddress" className="form-label">UF</label>
                            <input type="text" value={uf} className="form-control" id="inputCodigo" tabIndex="1" required autoComplete="off"/>
                        </div>
                        <div className="col-4">
                            <label htmlFor="inputAddress" className="form-label">CIDADE</label>
                            <input type="text" value={cidade} className="form-control" id="inputCodigo" tabIndex="1" required autoComplete="off"/>
                        </div>
                        <div className="col-1">
                            <label htmlFor="inputAddress" className="form-label">Nº</label>
                            <input type="text" value={nr} className="form-control" id="inputCodigo" tabIndex="1" required autoComplete="off"/>
                        </div>
                        <div className="col-2">
                            <label htmlFor="inputAddress" className="form-label">INSC EST</label>
                            <input type="text" value={inscEstadual} className="form-control" id="inputCodigo" tabIndex="1" required autoComplete="off"/>
                        </div>
                        <div className="col-2">
                            <label htmlFor="inputAddress" className="form-label">INSC MUN</label>
                            <input type="text" value={inscMunicipal} className="form-control" id="inputCodigo" tabIndex="1" required autoComplete="off"/>
                        </div>
                        <div className="col-3">
                            <label htmlFor="inputAddress" className="form-label">BAIRRO</label>
                            <input type="text" value={bairro} className="form-control" id="inputCodigo" tabIndex="1" required autoComplete="off"/>
                        </div>


                        <div className="col-7">
                            <label htmlFor="inputAddress" className="form-label">ENDEREÇO</label>
                            <input type="text" value={endereco} className="form-control" id="inputCodigo" tabIndex="1" required autoComplete="off"/>
                        </div>
                        <div className="col-2">
                            <label htmlFor="inputAddress" className="form-label">FONE</label>
                            <input type="text" value={fone} className="form-control" id="inputCodigo" tabIndex="1" required autoComplete="off"/>
                        </div>




                      </div>
                      
                      </div>
                    </div>
                  </div>

            <hr className="mt-4" />
            <h5>Itens do Pedido</h5>

            {/* 👉 Adição de Item Inline */}
            <div id="section-add-item" className="card p-3 mb-4 shadow-sm">
              <h6>Adicionar Item (F2 / F7)</h6>
              <div className="row g-2">
                <div className="col-1 mt-3">
                  <label>Qtd</label>
                  <NumericFormat
                    className="form-control"
                    value={itemQtd}
                    decimalScale={3}
                    onValueChange={(values) => setItemQtd(values.floatValue)}
                    readOnly
                    
                  />
                </div>
                <div className="col-2 mt-3">
                  <label>Código (F8)</label>
                  <div className="input-group">
                   <input
  id="inputCod"
  value={itemCodProduto}
  onChange={(e) => {
    const valor = e.target.value;
    if (valor.includes('*')) {
      const [qtdStr, codStr] = valor.split('*');
      const qtd = parseFloat(qtdStr.replace(',', '.')) || 1;
      const cod = codStr || '';
      setItemQtd(qtd);
      setItemCodProduto(cod);
    } else {
      setItemCodProduto(valor);
    }
  }}
  onKeyDown={(e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      buscaItem(); // 🚀 isso agora busca e adiciona direto
    }
  }}
  onBlur={buscaItem} // mantém o comportamento original
  className="form-control"
  autoFocus
/>
                    <button className="btn btn-primary" type="button" onClick={() => setIsProdutoOpen(true)}>
                      <i className="fas fa-search" />
                    </button>
                  </div>
                </div>

                <div className="col-4 mt-3">
                  <label>Descrição</label>
                  <input type="text" value={itemDescricao} onChange={(e) => setItemDescricao(e.target.value)} className="form-control" readOnly />
                </div>

                <div className="col-1 mt-3">
                  <label>Venda</label>
                  <NumericFormat
                    className="form-control"
                    value={Number(itemVendaDefault)}
                    onBlur={() => setItemTotal(Number(itemVendaDefault * itemQtd))}
                    allowLeadingZeros
                    decimalSeparator=','
                    thousandSeparator='.'
                    decimalScale={2}
                    prefix='R$ '
                    readOnly
                    fixedDecimalScale
                  />
                </div>

                

                {itemCampoVisivel && (
                  <div className="col-1 mt-3">
                    <label>Desconto</label>
                    <NumericFormat
                      className="form-control"
                      value={itemDesconto}
                      decimalScale={2}
                      onValueChange={(v) => setItemDesconto(v.floatValue)}
                      decimalSeparator=','
                      thousandSeparator='.'
                      prefix='R$ '
                      fixedDecimalScale

                    />
                  </div>
                )}

                <div className="col-1 mt-3">
                  <label>Total</label>
                  <NumericFormat
                    className="form-control"
                    value={itemTotalComDesconto}
                    decimalScale={2}
                    prefix="R$ "
                    readOnly
                    decimalSeparator=','
                    thousandSeparator='.'
                    fixedDecimalScale
                  />
                </div>

                {/* <div className="col-2 mt-4 ">
                  <button className="btn btn-danger me-2" onClick={itemMostrarCampo}><i className='bi bi-cash-coin'></i> (F6)</button>
                  
                </div> */}

             
              </div>
            </div>

            {/* Lista de Itens */}
            <table className="table table-hover table-striped">
              <thead>
                <tr>
                  <th>Código</th>
                  <th>Descrição</th>
                  <th>Qtd</th>
                  <th>Venda</th>
                  <th>Desconto</th>
                  <th>Total</th>
                  <th>Ação</th>
                </tr>
              </thead>
             <tbody className="table-group-divider">
  {Itens.length > 0 ? (
    Itens.map((item) => (
      <tr key={item.ITEM}>
        <td>{item.COD_PRODUTO}</td>
        <td>{item.DESCRICAO}</td>
        <td>{Number(item.QTD).toFixed(3)}</td>
        <td>
          {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.VENDA)}
        </td>
       <td>
  {item.editandoDesconto ? (
    <input
      type="text"
      className="form-control form-control-sm"
      autoFocus
      value={formatCurrencyInput(item.novoDesconto ?? item.DESCONTO)}
      onChange={(e) => handleDescontoChange(item.ITEM, e.target.value)}
      onBlur={() => salvarDesconto(item)}
      onKeyDown={(e) => {
        if (e.key === "Enter") salvarDesconto(item);
        if (e.key === "Escape") cancelarEdicao(item.ITEM);
      }}
      style={{ width: "100px", textAlign: "right" }}
    />
  ) : (
    new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(item.DESCONTO)
  )}
</td>
        <td>
          {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.TOTAL)}
        </td>
        <td>
          <div className="dropdown">
            <button
              className="btn btn-link dropdown-toggle text-dark"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="bi bi-gear-fill"></i>
            </button>
            <ul className="dropdown-menu">
              <li>
                <button
                  className="dropdown-item text-danger"
                  onClick={(e) => {
                    e.preventDefault();
                    confirmadeleteUser(item.ITEM);
                  }}
                >
                  <i className="bi bi-trash-fill me-2"></i>Excluir
                </button>
              </li>
              <li>
                <button
                  className="dropdown-item text-primary"
                  onClick={() => editarDesconto(item.ITEM)}
                >
                  <i className="bi bi-pencil-fill me-2"></i>Aplicar Desconto
                </button>
              </li>
            </ul>
          </div>
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="7" className="text-center">Nenhum item adicionado</td>
    </tr>
  )}
</tbody>
            </table>
          </form>
          <div className='d-flex justify-content-end mt-4 mb-3'>
              <button className="btn btn-primary" ><i className='bi bi-cart-check-fill'></i>Pagamentos (F7)</button>
          </div>
        </div>

        {/* ========================= COLUNA DIREITA ========================= */}
        <div className="col-lg-4 col-md-5 col-sm-12 p-3 bg-white shadow-sm rounded" id="section-pagamento">
          <h5>Recebimento</h5>

          <div className="d-flex justify-content-between mb-3">
            <Card title="Sub-total" style={{ borderLeft: 'solid 5px #FFA500' }} value={formatCurrency(totalPedido)} />
            <Card title="Desconto" style={{ borderLeft: 'solid 5px #dc3545' }} value={formatCurrency(totalDesconto)} />
            <Card title="Total" style={{ borderLeft: 'solid 5px #28a745' }} value={formatCurrency(totalComDesconto)} />
          </div>

          <div className="mb-3">
            <select onChange={handleChange} value={formaPag.descricao} id='select-pag' className="form-select form-select-lg">
              <option value="">Selecione a forma de pagamento(F7)</option>
              {finalizadorasFiltradas.map((forma) => (
                <option key={forma.COD_FINALIZADORA} value={forma.DESCRICAO}>
                  {forma.COD_FINALIZADORA} - {forma.DESCRICAO}
                </option>
              ))}
            </select>
          </div>

          {formaPag.codigo === 2 || formaPag.codigo === 3 ? (
            <div className="mb-3">
            <select onChange={handleChangeRede} value={redePag.nome} id='select-pag' className="form-select form-select-lg">
              <option value="">Selecione a operadora</option>
              {redes.map((forma) => (
                <option key={forma.N_LOGICO} value={forma.NOME_REDE}>
                  {forma.NOME_REDE}
                </option>
              ))}
            </select>
          </div>
          )

          

         : null}

          <div className="mb-3">
            <label>Valor a ser pago</label>
            <NumericFormat
              className="form-control"
              value={valorASerPago}
              onValueChange={(values) => setValorASerPago(values.value)}
             thousandSeparator="."
             decimalSeparator=","
             decimalScale={2}
             fixedDecimalScale
             prefix="R$ "
            />
          </div>

          <div className="d-flex gap-2 justify-content-between flex-wrap">
  {valorRestante > 0 ? (
    <button type='button' id='botao-gravar' 
  onKeyDownCapture={(e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
    }
  }}
  className="btn btn-primary flex-fill" onClick={registrarPagamento}>
      Registrar Pagamento (F9)
    </button>
  ) : (
    <button type='button' id='botao-gravar' 
   onKeyDownCapture={(e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
    }
  }}
  className="btn btn-success flex-fill" onClick={gravaRecebimentos}>
      Finalizar (F9)
    </button>
  )}
  
</div>

          <hr />
          <h6>Pagamentos Realizados</h6>
          <ul className="list-group mt-3">
  {pagamentos.map((pagamento, index) => (
    <li
      key={index}
      className="list-group-item d-flex justify-content-between align-items-center"
    >
      <span className="row w-100">
  <span className="col-7 text-start fw-semibold text-secondary">
    {pagamento.formaPagamento}
  </span>
  <span className="col-5 text-end pr-5 fw-bold text-success">
    {pagamento.valor.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    })}
  </span>
</span>
      <button
        className="btn btn-outline-danger btn-sm"
        onClick={() => removerPagamento(index)}
      >
        <i className="bi bi-trash-fill"></i>
      </button>
    </li>
  ))}
</ul>

          <h6 className="mt-3">Troco: {troco.toLocaleString("pt-br", { style: "currency", currency: "BRL" })}</h6>

          <div className='d-flex justify-content-end mt-4 mb-3'>
            <button className="btn btn-danger " onClick={(e) => setNavegar(true)}>
    Cancelar Venda
  </button>
          </div>
        </div>
      </div>
      {/* === SWEETALERTS DE NAVEGAÇÃO / CONFIRMAÇÃO === */}

{sucessoBusca && (
  <SweetAlert
    danger
    confirmBtnText="OK"
    confirmBtnBsStyle="danger"
    title="Algo deu errado"
    onConfirm={() => setSucessoBusca(false)}
  >
    Produto não encontrado
  </SweetAlert>
)}

{erroEmissao && (
  <SweetAlert
    danger
    confirmBtnText="OK"
    confirmBtnBsStyle="danger"
    title="Erro"
    onConfirm={() => setErroEmissao(false)}
  >
    {msgErro}
  </SweetAlert>
)}

<>
  {/* Overlay de carregamento com fade animado */}
  <AnimatePresence>
    {load && (
      <motion.div
        key="loading-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
        className="position-fixed top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center bg-dark bg-opacity-50"
        style={{ zIndex: 2000 }}
      >
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="d-flex flex-column justify-content-center align-items-center"
        >
          <div
            className="spinner-border text-light"
            style={{ width: '3rem', height: '3rem' }}
            role="status"
          ></div>
          <p className="text-light mt-3 fs-5">Emitindo nota fiscal...</p>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>


  
  {escolhaNota && (
    <SweetAlert
      info
      showCloseButton
      title="Emissão de Nota"
      onCancel={() => setConfirmacao(false)}
      showConfirm={false}
      showCancel={false}
    >
      <p>Escolha a opção de emissão de nota fiscal:</p>
      <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '20px' }}>
        <button
          onClick={() => enviarNFce(numeroPedido, 65)}
          id="botao-escolha-nfce"
          style={{ 
            padding: '10px 20px', 
            backgroundColor: '#007bff', 
            color: '#fff', 
            border: 'none', 
            borderRadius: '5px',
            opacity: load ? 0.7 : 1,
            cursor: load ? 'not-allowed' : 'pointer'
          }}
          disabled={load}
        >
          {load ? 'Processando...' : 'NFC-e (ALT + N)'}
        </button>
        <button
          onClick={() => enviarNFce(numeroPedido, 55)}
          id="botao-escolha-nfe"
          style={{ 
            padding: '10px 20px', 
            backgroundColor: '#28a745', 
            color: '#fff', 
            border: 'none', 
            borderRadius: '5px',
            opacity: load ? 0.7 : 1,
            cursor: load ? 'not-allowed' : 'pointer'
          }}
          disabled={load}
        >
          {load ? 'Processando...' : 'NF-e (ALT + S)'}
        </button>
      </div>
    </SweetAlert>
  )}

  {/* Confirmação padrão com CNPJ */}
  {notaCnpj && (
    <SweetAlert
      info
      showCloseButton
      title="Emissão de Nota"
      onCancel={() => setConfirmacao(false)}
      showConfirm={false}
      showCancel={false}
    >
      <p>Deseja emitir nota fiscal?</p>
      <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '20px' }}>
        <button
          onClick={() => vendaSemNfce(numeroPedido)}
          id="botao-venda-sem-nfce"
          style={{ padding: '10px 20px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '5px' }}
          disabled={load}
        >
          Não (ALT + N)
        </button>
        <button
          onClick={() => enviarNFce(numeroPedido, 55)}
          id="botao-emite-nfe"
          style={{ 
            padding: '10px 20px', 
            backgroundColor: '#28a745', 
            color: '#fff', 
            border: 'none', 
            borderRadius: '5px',
            opacity: load ? 0.7 : 1,
            cursor: load ? 'not-allowed' : 'pointer'
          }}
          disabled={load}
        >
          {load ? 'Emitindo...' : 'Sim (ALT + S)'}
        </button>
      </div>
    </SweetAlert>
  )}

  {/* Confirmação padrão sem CNPJ */}
  {notaCadPadrao && (
    <SweetAlert
      info
      showCloseButton
      title="Emissão de Nota"
      onCancel={() => setConfirmacao(false)}
      showConfirm={false}
      showCancel={false}
    >
      <p>Deseja emitir nota fiscal?</p>
      <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '20px' }}>
        <button
          onClick={() => vendaSemNfce(numeroPedido)}
          id="botao-venda-sem-nfce-padrao"
          style={{ padding: '10px 20px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '5px' }}
          disabled={load}
        >
          Não (ALT + N)
        </button>
        <button
          onClick={() => enviarNFce(numeroPedido, 65)}
          id="botao-emite-nfe-padrao"
          style={{ 
            padding: '10px 20px', 
            backgroundColor: '#28a745', 
            color: '#fff', 
            border: 'none', 
            borderRadius: '5px',
            opacity: load ? 0.7 : 1,
            cursor: load ? 'not-allowed' : 'pointer'
          }}
          disabled={load}
        >
          {load ? 'Emitindo...' : 'Sim (ALT + S)'}
        </button>
      </div>
    </SweetAlert>
  )}
</>

{confirmacao && (
  <SweetAlert
    warning
    showCancel
    showCloseButton
    confirmBtnText="Sim"
    confirmBtnBsStyle="danger"
    cancelBtnText="Não"
    cancelBtnBsStyle="light"
    title="Atenção"
    onConfirm={() => deleteUser(confirmacaoId)}
    onCancel={() => setConfirmacao(false)}
    focusCancelBtn
    reverseButtons
  >
    Deseja excluir este item?
  </SweetAlert>
)}

{erroValidacao && (
  <SweetAlert
    danger
    confirmBtnText="OK"
    confirmBtnBsStyle="danger"
    title="Erro"
    onConfirm={() => setErrovalidacao(false)}
  >
    {msgErro}
  </SweetAlert>
)}

{confirmaEmissao && (
  <SweetAlert
    success
    confirmBtnText="OK"
    confirmBtnBsStyle="success"
    title="Parabéns"
    onConfirm={() => fecharTelaVenda()}
  >
    Nota emitida com sucesso!
  </SweetAlert>
)}

{confirmaVenda && (
  <SweetAlert
    success
    confirmBtnText="OK"
    confirmBtnBsStyle="success"
    title="Parabéns"
    onConfirm={() => fecharTelaVenda()}
  >
    Venda efetuada com sucesso!
  </SweetAlert>
)}

{confirmaPagamento && (
  <SweetAlert
    success
    confirmBtnText="OK"
    confirmBtnBsStyle="success"
    title="Parabéns"
    onConfirm={() => fecharVenda()}
  >
    Troco a devolver: {troco.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
  </SweetAlert>
)}

{mensagem.length > 0 && (
  <div className="alert alert-danger mt-2" role="alert">{mensagem}</div>
)}

{navegar && <Navigate to="/app/listapedidos" />}
{sucesso === 'S' && <Navigate to="/app/listapedidos" />}

    </div>

    <FooterBar />
   <ModalProduto
  isOpen={isProdutoOpen}
  onRequestClose={() => setIsProdutoOpen(false)}
  titulo="Pesquisa de Produto"
  setCodProduto={(cod) => handleSelecionaProdutoModal(cod)}
  setDescricao={setItemDescricao}
  setVendaDefault={setItemVendaDefault}
  setCompra={setItemCompra}
  setNcm={setItemNcm}
  setEstoque={setItemEstoque}
/>
  </div>

  
);
}

export default NovoPedidoPOS;
